enum SectionTypes {
  Regular = 0,
  ForCorporate = 1,
  ForNonCorporate = 2
}

export default SectionTypes;
